import { _api } from '@/utils/apiAxios';
import { getField, updateField } from 'vuex-map-fields';
import { LoginTypes, ExternalWagerLoginTypes } from '@/utils/enums';
import { getRootDomain } from '@/utils/common';
import { isElectronContext } from '../../utils/isElectron';
const isElectron = isElectronContext();

import { playerService } from '../../services';
import Cookies from 'js-cookie';
import store from '@/store';

const TOKEN = 'PREF_JWT_TOKEN';
const LOGIN_TYPE = 'LOGIN_TYPE';
const PLAYER = 'PREF_PLAYER';
const CLERK = 'PREF_CLERK';
const LOGIN_SESSION_DAYS = 90;

export function getPlayerFromLocalStorage() {
  // const res = await playerService.getPlayerLoginDetails();
  return localStorage.getItem(PLAYER) ? localStorage.getItem(PLAYER) : '{}';
}

function getClerkFromLocalStorage() {
  return Cookies.get(CLERK);
}

export function getTokenFromLocalStorage() {
  return Cookies.get(TOKEN);
}

export function isLogged() {
  return getTokenFromLocalStorage() != undefined;
}

export function removeTokenAndPlayer(withoutReload = false) {
  return new Promise((resolve, reject) => {
    Cookies.remove(TOKEN, { domain: getRootDomain(location.hostname) });
    Cookies.remove(LOGIN_TYPE, { domain: getRootDomain(location.hostname) });
    Cookies.remove(PLAYER, { domain: getRootDomain(location.hostname) });
    Cookies.remove(CLERK, { domain: getRootDomain(location.hostname) });
    localStorage.removeItem(PLAYER);
    localStorage.removeItem('PREF_SCAN_CODE');
    localStorage.removeItem('PREF_INACTIVITY_CHECKER_INITIAL_SECONDS');
    localStorage.removeItem('PREF_INACTIVITY_CHECKER_REMAINING_SECONDS');
    localStorage.removeItem('clerkSessionID');

    const isPreProd = window.location.href.includes('ib-engine');
    const isStaging = window.location.href.includes('engine-stg');
    const isFv3Stage = window.location.href.includes('engine-fv3');

    if (!withoutReload) {
      if (isElectron) {
        window.location.href = '/';
        return;
      }

      let guestUrl = localStorage.getItem('guest_url');

      if (guestUrl && isFv3Stage) {
        window.location.href = guestUrl.replace('/api', '');
      }
      else if (guestUrl && !isStaging && !isPreProd) {
        window.location.href = guestUrl;
      }
      else if (isPreProd) {
        window.location.href = window.location.href.split('?')[0];
      }
      else {
        window.location.href = window.location.href.split('?')[0];
      }
    }
    resolve();
  });
}

export function doLogout() {
  return new Promise((resolve, reject) => {
    removeTokenAndPlayer().then(() => {
      resolve();
    });
  });
}

function getLoginType() {
  return Cookies.get(LOGIN_TYPE) || LoginTypes.Guest;
}

export function isClerkOrPlayer() {
  return isClerk() || isPlayer();
}

function isPlayer() {
  return getLoginType() === LoginTypes.Player;
}

function isClerk() {
  return getLoginType() === LoginTypes.Clerk || getLoginType() === ExternalWagerLoginTypes.ClerkDepositTicket;
}

const state = {
  balance: {},
  player: {},
  clerk: getClerkFromLocalStorage() ? JSON.parse(getClerkFromLocalStorage()) : {},
  isLogged: isClerkOrPlayer() || getLoginType() === ExternalWagerLoginTypes.DepositTicket,
  isClerk: isClerk(),
  openLogoutModal: false,
  loginType: getLoginType(),
  rollover: null,
  loginDetailsLoading: false,
  balanceLoading: false,
  rolloverLoading: false
};

const getters = {
  getField,
  isPlayerOrClerkLoggedIn: state => {
    return (state.isClerk && state.isLogged) || (state.loginType === LoginTypes.Player && state.isLogged);
  },

  player: state => state.player,
  currencySymbol: state => {
    if (state.loginType === LoginTypes.Player && state.player.PlayerInfo) {
      return state.player.PlayerInfo.DGS.currency_symbol;
    }
    return '';
  },
  currency: state => {
    if (state.loginType === LoginTypes.Player) {
      return state.player.PlayerInfo.DGS.currency;
    }
    return '';
  },
  isInUs: state => {
    if (state.loginType === LoginTypes.Player) {
      return state.player.PlayerInfo.address_country;
    }
    return false;
  },
  hasMissingData: state => {
    let isAddresStateFill = !state.player.PlayerInfo.address_state;
    if (window.location.hostname.includes('instabet.net')) {
      isAddresStateFill = false;
    }

    return !state.player.PlayerInfo.primary_phone || !state.player.PlayerInfo.address_country || isAddresStateFill;
  },
  country: state => (state.loginType === LoginTypes.Player ? state.player.PlayerInfo.address_country : 'US'),
  fullName: state => {
    if (state.loginType === LoginTypes.Player) {
      return state.player.PlayerName + ' ' + state.player.PlayerLastName;
    }
    if (state.loginType === LoginTypes.Clerk || state.loginType === ExternalWagerLoginTypes.ClerkDepositTicket) {
      return state.clerk.account_name;
    }
    if (state.loginType === ExternalWagerLoginTypes.DepositTicket) {
      return 'Anonymous';
    }

    return '';
  },
  isDepositTicket: state =>
    state.loginType === ExternalWagerLoginTypes.DepositTicket ||
    state.loginType === ExternalWagerLoginTypes.ClerkDepositTicket,
};

const mutations = {
  updateField,
  setPlayer(state, player) {
    state.player = player;
    localStorage.setItem(PLAYER, JSON.stringify(player));
    // Cookies.set(PLAYER, JSON.stringify(player), {
    //     expires: LOGIN_SESSION_DAYS,
    //     domain: getRootDomain(location.hostname)
    // });
  },

  setPlayerRollover(state, rollover) {
    state.rollover = rollover;
  },
  setToken(state, token) {
    console.log(token);
    Cookies.set(TOKEN, token, {
      expires: LOGIN_SESSION_DAYS,
      domain: getRootDomain(location.hostname),
    });
  },
  setLoginType(state, val) {
    Cookies.set(LOGIN_TYPE, val, {
      expires: LOGIN_SESSION_DAYS,
      domain: getRootDomain(location.hostname),
    });
    state.loginType = val;
    state.isLogged = true;
  },
  setBalance(state, balanceObject) {
    state.balance = balanceObject;
  },
  setLogout(state) {
    state.balance = {};
    state.isLogged = false;
    state.isClerk = false;
    state.player = {};
    state.clerk = {};
    if (state.loginType !== ExternalWagerLoginTypes.MobileScanCode) state.loginType = LoginTypes.Guest;
  },
  setClerk(state, clerk) {
    state.clerk = clerk;
    state.isClerk = true;
    Cookies.set(CLERK, JSON.stringify(clerk), {
      expires: LOGIN_SESSION_DAYS,
      domain: getRootDomain(location.hostname),
    });
  },
  setLoginDetailsLoading(state, val) {
    state.loginDetailsLoading = val;
  },
  setBalanceLoading(state, val) {
    state.balanceLoading = val;
  },
  setRolloverLoading(state, val) {
    state.rolloverLoading = val;
  },
};

const actions = {
  logout({ commit, rootState }, callback) {
    _api.get(rootState.player.loginType === LoginTypes.Clerk ? '/logout-clerk' : '/player/logout').finally(() => {
      rootState.settings.loyaltyCardResponse = null;
      doLogout();
      commit('setLogout');
    });
  },
  tryGetSessionSummary({ commit }) {
    return new Promise((resolve, reject) => {
      _api
        .get('/player/session-info')
        .then(r => {
          if (r.data.IsSuccess) {
            resolve(r.data);
          } else {
            reject(r);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async logoutAndRefresh({ commit, rootState }, data) {
    _api.get(rootState.player.loginType === LoginTypes.Clerk ? '/logout-clerk' : '/player/logout').finally(() => {
      const selections = localStorage.getItem('new_selections');
      if (selections) {
        localStorage.removeItem('new_selections');
      }
      const bets = localStorage.getItem('new_betslip');
      if (bets) {
        localStorage.removeItem('new_betslip');
      }

      rootState.settings.loyaltyCardResponse = null;
      const logoutAfterCallback = data && data.logoutAfterCallback;
      if (!logoutAfterCallback) {
        doLogout();
        commit('setLogout');
      }
      const callback = data && data.callback;
      callback && callback();
    });
    // location.href = "/";
    // TODO: this line is added for now to reset vuex state.
    // later vuex will be cleared manually
    // if(!!isElectron || rootState.settings.clientType === 'ANDROID_TABLET') {
    //     location.href = "/";
    // }else {
    //     location.href = "http://" + rootState.settings.brandSettings.brand_name.toLowerCase().replace(' ', '.');
    // }
  },
  async logoutAndReconcilate({ commit, rootState }, data) {
    _api.get('/clerk/dailybalancereconcilationandlogout').finally(() => {
      const logoutAfterCallback = data && data.logoutAfterCallback;
      if (!logoutAfterCallback) {
        doLogout();
        commit('setLogout');
      }
      const callback = data && data.callback;
      callback && callback();
    });
    // location.href = "/";
    // TODO: this line is added for now to reset vuex state.
    // later vuex will be cleared manually
    // if(!!isElectron || rootState.settings.clientType === 'ANDROID_TABLET') {
    //     location.href = "/";
    // }else {
    //     location.href = "http://" + rootState.settings.brandSettings.brand_name.toLowerCase().replace(' ', '.');
    // }
  },
  tryGetBalance({ commit }) {
    commit('setBalanceLoading', true);
    _api.get('/player/balance').then(r => {
      if (r.data.IsSuccess) {
        commit('setBalance', r.data.Data);
        commit('setBalanceLoading', false);
      }
    });
  },
  tryGetFreshPlayer({ commit, dispatch,state }) {
    commit('settings/setSelectedOddLoading', true, { root: true });
    _api.get('/player/fresh').then(r => {
      if (r.data.IsSuccess) {
        console.log("test");
        const player = r.data.Data;

        const lineStyle = player.LyneStyle || 'E';
        console.log({lineStyle})
        commit('settings/setSelectedOddType', lineStyle, { root: true });
      }
      commit('settings/setSelectedOddLoading', false, { root: true });
      //When the line style is changed on the guest side, it stays the same after login, so the oddbanner data was called again after fresh.
      dispatch('betLines/getMostPlayedGames', store.state.sportMenu.activeLeagueId, { root: true })
    });
  },
  getPlayerData({ dispatch, state }, data) {
    if (state.player.PlayerAccount) {
      if (state.loginType === LoginTypes.Player) {
        dispatch('tryGetFreshPlayer');
        dispatch('tryGetBalance');
        dispatch('openBetsStore/tryGetOpenBets', null, { root: true });
        dispatch('freeWagerStore/tryGetAvailableFreeWagers', null, {
          root: true,
        });
      }
      if (state.loginType === ExternalWagerLoginTypes.DepositTicket) {
        dispatch('depositTicketStore/tryScanBarcode', null, { root: true });
      }
    }
    // dispatch('betSlip/getBetTabs', null, { root: true });
    // dispatch('betSlip/getBetOptions', { checkLineAvailability: true }, { root: true });
  },
  getMessages() {
    return _api.get('/player/messages');
  },
  getPlayerLoginDetail({ commit, dispatch }) {
    commit('setLoginDetailsLoading', true);
    return playerService
      .getPlayerLoginDetails()
      .then(res => {
        if (res.data.Data.Player && res.data.Data.Player.PlayerMessages.length > 0) {
          res.data.Data.Player.PlayerMessages = res.data.Data.Player.PlayerMessages.map(item => ({
            ...item,
            status: true,
          }));
        }

        commit('setPlayer', res.data.Data.Player);
        dispatch('getPlayerData', null);
        commit('setLoginDetailsLoading', false);
      })
      .catch(err => {
        let res = removeTokenAndPlayer();
      });
  },
  getPlayerRolloverDetail({ commit, }) {
    commit('setRolloverLoading', true)
    return playerService
      .getPlayerRolloverDetails()
      .then(res => {
        commit('setPlayerRollover', res.data.Data);
        commit('setRolloverLoading', false)
      })
      .catch(err => {
        let res = removeTokenAndPlayer();
        commit('setRolloverLoading', false)
      });
  },
  clearDeposit({ commit, rootState }, withoutReload) {
    _api
      .post('/customers/endcustomersession', {
        mac_address: rootState.settings.macAddress,
      })
      .finally(async () => {
        if (!withoutReload) {
          let res = await removeTokenAndPlayer(true);
          commit('setLogout');
        }
      });
  },
};

export const player = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
